<template>
  <div>
    <v-col cols="12">
      <v-row>
        <v-text-field
          v-model="search"
          label="Search..."
          dense
          outlined
          hide-details
          class="shrink mx-4"
          title="Search By Title, Product Code, Idea"
        ></v-text-field>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-row>
    </v-col>

    <v-simple-table fixed-header style="text-align: left">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" width="15%">Account ID</th>
            <th class="text-left">Campaign</th>
            <th class="text-left">Product Thumb</th>
            <th class="text-left" width="30%">Product</th>
            <th class="text-left">Total Orders</th>
            <th class="text-left">Total Sales</th>
            <th class="text-left">Revenue</th>
            <th class="text-left" @click="sortData('google_ad_spent')">
              GG Ad Spent
              <v-icon x-small v-if="sortBy == 'google_ad_spent' && !sortType"
                >mdi-arrow-up</v-icon
              >
              <v-icon
                x-small
                v-else-if="sortBy == 'google_ad_spent' && sortType"
                >mdi-arrow-down</v-icon
              >
              <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
            </th>

            <th class="text-left" @click="sortData('avg_cpp')">
              AVG Cost per Order
              <v-icon x-small v-if="sortBy == 'avg_cpp' && !sortType"
                >mdi-arrow-up</v-icon
              >
              <v-icon x-small v-else-if="sortBy == 'avg_cpp' && sortType"
                >mdi-arrow-down</v-icon
              >
              <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
            </th>

            <th class="text-left" @click="sortData('temp_net_profit')">
              Temp Net Profit
              <v-icon x-small v-if="sortBy == 'temp_net_profit' && !sortType"
                >mdi-arrow-up</v-icon
              >
              <v-icon
                x-small
                v-else-if="sortBy == 'temp_net_profit' && sortType"
                >mdi-arrow-down</v-icon
              >
              <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
            </th>
          </tr>
        </thead>

        <tbody>
          <template v-for="(item, indexitem) in filterItems">
            <tr :key="indexitem">
              <td :rowspan="item.products.length">
                {{ item.account_id }}
              </td>
              <td :rowspan="item.products.length">
                <b>{{ item.campaign_id }}</b>
                <div>{{ item.campaign_name }}</div>
              </td>
              <td>
                <img :src="item.products[0].thumbnail" width="100px" />
              </td>
              <td>
                {{ item.products[0].product_code }} -
                {{ item.products[0].product_title }}
              </td>
              <td>{{ item.products[0].total_orders }}</td>
              <td>{{ item.products[0].total_sales }}</td>
              <td>{{ item.products[0].revenue.toFixed(2) }}</td>
              <td :rowspan="item.products.length">
                {{ item.google_ad_spent.toFixed(2) }}
              </td>
              <td :rowspan="item.products.length">
                <template v-if="item.avg_cpp">
                  {{ item.avg_cpp.toFixed(2) }}
                </template>
              </td>
              <td :rowspan="item.products.length">
                {{ item.temp_net_profit.toFixed(2) }}
              </td>
            </tr>

            <template v-for="(row, index) in item.products">
              <tr :key="item.campaign_id + '-' + index" v-if="index != 0">
                <td>
                  <img :src="item.products[index].thumbnail" width="100px" />
                </td>
                <td>
                  {{ item.products[index].product_code }} -
                  {{ item.products[index].product_title }}
                </td>
                <td>{{ item.products[index].total_orders }}</td>
                <td>{{ item.products[index].total_sales }}</td>
                <td>{{ item.products[index].revenue.toFixed(2) }}</td>
              </tr>
            </template>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import axios from "axios";
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "GGCampPerform",

  props: {
    report_type: String,
    report_month: Array,
    store_codes: Array,
  },

  data: () => ({
    reportData: [],
    loading: false,
    search: null,
    sortBy: "",
    sortType: null,
    filterItems: [],
  }),

  watch: {
    search() {
      this.filterData(this.search);
    },
  },

  methods: {
    async loadData() {
      this.loading = true;
      this.reportData = [];

      var queryParams = {
        report_type: this.report_type,
        store_codes: this.store_codes.join(","),
      };

      if (this.report_month.length > 0) {
        if (this.report_month[0] > this.report_month[1]) {
          queryParams["report_from"] = this.report_month[1];
          queryParams["report_to"] = this.report_month[0];
        } else {
          queryParams["report_from"] = this.report_month[0];
          queryParams["report_to"] = this.report_month[1];
        }
      }

      console.log(queryParams);

      var currentSession = await this.$root.$refs.App.currentSession(
        "GG-camp-profit-loadData"
      );
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "reports/profit", {
            headers: { Authorization: currentSession.accessToken },
            params: queryParams,
          })
          .then((response) => {
            console.log("response: ", response);
            for (var id in response.data.data) {
              this.reportData.push(response.data.data[id]);
            }
            this.filterItems = JSON.parse(JSON.stringify(this.reportData));
            console.log("this.filterItems: ", this.filterItems);
            this.loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession GG-camp-profit-loadData-undefined: ",
          currentSession
        );
      }
    },

    sortData(col) {
      this.sortBy = col;
      if (this.sortType == null) {
        this.sortType = false;
      } else {
        this.sortType = !this.sortType;
      }

      if (this.sortType == false)
        this.filterItems.sort((a, b) => (a[col] > b[col] ? 1 : -1));
      else this.filterItems.sort((a, b) => (a[col] < b[col] ? 1 : -1));
    },

    filterData(input) {
      //console.log("input: ", input);
      input = input.toLowerCase();
      if (input != "") {
        this.filterItems = [];

        this.filterItems = this.reportData.filter(
          (t) =>
            t.campaign_id.toLowerCase().indexOf(input) > -1 ||
            t.campaign_name.toLowerCase().indexOf(input) > -1 ||
            t.account_id.toLowerCase().indexOf(input) > -1
        );
      } else {
        this.filterItems = JSON.parse(JSON.stringify(this.reportData));
      }
    },
  },

  async mounted() {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>


<style scoped>
.v-data-table /deep/ .sticky-header {
  position: sticky;
  top: 0;
}

.v-data-table /deep/ .v-data-table__wrapper {
  overflow: unset;
}
</style>